import React from "react";
import useElements from "../hooks/useElements";
const BackgroundContainer = props => {
  const {
    value: initValue,
    className,
    children,
    withOverlay = false
  } = props;
  const {
    base
  } = useElements();
  const Head = base?.Head;
  const src = initValue?.desktop?.src || initValue?.image?.src || initValue?.url || typeof initValue === "string" ? initValue : "";
  const isVisible = true;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: {
      position: withOverlay && "relative",
      backgroundImage: isVisible && src ? `url('${src}')` : undefined,
      backgroundPosition: "center center",
      backgroundSize: "cover"
    }
  }, /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("link", {
    key: "__nimg-" + src,
    rel: "preload",
    as: "image",
    href: src
  })), withOverlay && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    className: withOverlay
  }), withOverlay ? /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative"
    }
  }, children) : children);
};
export default BackgroundContainer;
//# sourceMappingURL=BackgroundContainer.js.map